import { Avatar, Badge, Tooltip, Typography } from '@mui/material'
import ErrorIcon from '@mui/icons-material/Error'

import { useStyles } from '../styles'

interface IUserAvatarProps {
  alt: string
  src: string
  suspended: boolean
  mobile?: string | null
  withPopover?: boolean
}

const UserAvatar = ({ alt, src, suspended, mobile, withPopover }: IUserAvatarProps) => {
  const classes = useStyles()

  return (
    <Tooltip
      title={
        withPopover ? (
          <div>
            <Typography className={classes.title}>{alt}</Typography>
            {mobile && <Typography className={classes.subtitle}>{mobile}</Typography>}
          </div>
        ) : null
      }
    >
      <Badge
        overlap="circular"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        badgeContent={suspended ? <ErrorIcon className={classes.suspensionIcon} /> : null}
      >
        <Avatar alt={alt} src={src} className={classes.tableIcon} />
      </Badge>
    </Tooltip>
  )
}

export { UserAvatar }
